export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  color: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '娱乐爆料',
    slug: 'yule-baoliao',
    description: '娱乐圈最新内幕、明星八卦、影视圈黑料一网打尽',
    color: 'primary',
    icon: 'ri-movie-line',
  },
  {
    id: 'cat-2',
    name: '社会内幕',
    slug: 'shehui-neimu',
    description: '社会热点事件背后的真相与内幕揭秘',
    color: 'accent',
    icon: 'ri-building-line',
  },
  {
    id: 'cat-3',
    name: '科技黑料',
    slug: 'keji-heiliao',
    description: '科技巨头内幕、产品缺陷曝光、行业潜规则',
    color: 'primary',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'cat-4',
    name: '财经揭秘',
    slug: 'caijing-jiemi',
    description: '金融市场暗箱操作、企业财务黑幕深度调查',
    color: 'accent',
    icon: 'ri-money-dollar-circle-line',
  },
  {
    id: 'cat-5',
    name: '网红八卦',
    slug: 'wanghong-bagua',
    description: '网红圈内幕、直播带货真相、流量造假曝光',
    color: 'primary',
    icon: 'ri-live-line',
  },
  {
    id: 'cat-6',
    name: '政商秘闻',
    slug: 'zhengshang-miwen',
    description: '政商界不为人知的秘闻与深度调查报道',
    color: 'accent',
    icon: 'ri-government-line',
  },
];